import { STRING_ACCESS_TOKEN_ULTIMA_MILLA_V3 } from "../../utils/const/string-const";
import { urlGestion } from "./conexion";

export async function obtenerTodasLasUnidades() {
    try {
        let token = localStorage.getItem(STRING_ACCESS_TOKEN_ULTIMA_MILLA_V3);
        let obj = {};
        obj.token = token;
        let rows = [];
        let objDatos = {
            data_op: obj,
            op: "READ-OBTENERTODASLASUNIDADES",
        };
        let data = await fetch(urlGestion, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(objDatos),
        }).then((res) => res.json());
        // console.log('data');
        // console.log(data);
        if (data.error === false && data.data !== undefined) {
            rows = data.data;
        }
        return rows;
    } catch (err) {
        console.log("obtenerTodasLasUnidades err");
        console.log(err);
        return [];
    }
}

export async function obtenerInfoConductorConNumeroPlaca(obj) {
    try {
        let token = localStorage.getItem(STRING_ACCESS_TOKEN_ULTIMA_MILLA_V3);
        obj.token = token;
        let info = null;
        let objDatos = {
            data_op: obj,
            op: "READ-OBTENERINFOCONDUCTORCONNUMEROPLACA",
        };
        let data = await fetch(urlGestion, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(objDatos),
        }).then((res) => res.json());
        // console.log('data');
        // console.log(data);
        // debugger;
        if (data.error === false && data.data !== undefined) {
            info = data.data[0] !== undefined ? data.data[0] : null;
        }
        return info;
    } catch (err) {
        console.log("obtenerInfoConductorConNumeroPlaca err");
        console.log(err);
        return null;
    }
}

export async function obtenerPuntoActualVehiculo(placa) {
    try {
        let token = localStorage.getItem(STRING_ACCESS_TOKEN_ULTIMA_MILLA_V3);
        let obj = {};
        obj.token = token;
        obj.placa = placa;
        obj.esSubcuenta = '0';
        let objDatos = {
            data_op: obj,
            op: "READ-OBTENERPUNTOACTUALVEHICULOXPLACA",
        };
        let data = await fetch(urlGestion, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(objDatos),
        }).then((res) => res.json());
        // console.log('data');
        // console.log(data);
        if (
            data.error == false &&
            Array.isArray(data.data) &&
            data.data.length > 0
        ) {
            return data.data[0];
        }
        return null;
    } catch (err) {
        console.log("obtenerPuntoActualVehiculo err");
        console.log(err);
        return null;
    }
};

export async function obtenerTodasLasUnidadesExternal(idEmpresa) {
    try {
        let obj = {};
        obj.idEmpresa = idEmpresa;
        let rows = [];
        let objDatos = {
            data_op: obj,
            op: "READ-OBTENERTODASLASUNIDADES-EXTERNAL",
        };
        let data = await fetch(urlGestion, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(objDatos),
        }).then((res) => res.json());
        // console.log('data');
        // console.log(data);
        if (data.error === false && data.data !== undefined) {
            rows = data.data;
        }
        return rows;
    } catch (err) {
        console.log("obtenerTodasLasUnidadesExternal err");
        console.log(err);
        return [];
    }
}
